import React from 'react';

import PropTypes from 'prop-types';
import { RiErrorWarningFill } from 'react-icons/ri';
import { IoClose } from 'react-icons/io5';

import { Button } from 'modules/common/input';

function ReminderToast({ data, onViewDetails, onClose }) {
  const { order } = data || {};

  return (
    <div className="fixed bottom-5 right-5">
      <div className="card shadow-md">
        <div className="flex items-start gap-3">
          <div>
            <RiErrorWarningFill className="h-6 w-6 text-primary-500" />
          </div>
          <div className="-mt-0.5 w-72 space-y-3">
            <div>
              <div className="font-semibold">
                Prepare order #{order?.order_number || '-'}
              </div>
              <div className="text-sm text-gray-500">
                It&apos;s time to get order {order?.order_number || '-'} ready
                for delivery.
              </div>
            </div>

            <div className="flex gap-2 items-center">
              <Button
                className="btn bg-gray-900 text-white font-semibold sm"
                label="View Details"
                onClick={onViewDetails}
              />
              <Button
                className="btn font-semibold sm"
                label="Remind me later"
                onClick={onClose}
              />
            </div>
          </div>
          <div>
            <IoClose className="h-5 w-5 cursor-pointer" onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}

ReminderToast.defaultProps = {
  data: {},
  onViewDetails: () => {},
  onClose: () => {},
};

ReminderToast.propTypes = {
  data: PropTypes.instanceOf(Object),
  onViewDetails: PropTypes.instanceOf(Function),
  onClose: PropTypes.instanceOf(Function),
};

export default ReminderToast;
